export interface Store {
  id: string;
  name: string;
  slug: string;
  logo: string;
  banner: string;
  description: string;
  category: string;
  followers: number;
  rating: number;
  totalProducts: number;
  joinedYear: number;
  tags: string[];
}

export const stores: Store[] = [
  {
    id: 's1',
    name: 'Samsung',
    slug: 'samsung',
    logo: 'https://readdy.ai/api/search-image?query=Samsung%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-samsung-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Samsung%20flagship%20store%20interior%20modern%20minimalist%20retail%20space%20with%20sleek%20product%20displays%20ambient%20lighting%20premium%20brand%20experience%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-samsung-banner&orientation=landscape',
    description: 'Welcome to the Samsung Official Store on KenStore. Discover the latest Galaxy smartphones, tablets, smartwatches, home appliances, and more — all with official warranty and exclusive online deals.',
    category: 'official-stores',
    followers: 45800,
    rating: 4.6,
    totalProducts: 156,
    joinedYear: 2020,
    tags: ['electronics', 'smartphones', 'appliances', 'tvs'],
  },
  {
    id: 's2',
    name: 'Apple',
    slug: 'apple',
    logo: 'https://readdy.ai/api/search-image?query=Apple%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-apple-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Apple%20store%20interior%20modern%20minimalist%20retail%20space%20with%20wooden%20tables%20and%20product%20displays%20ambient%20lighting%20premium%20brand%20experience%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-apple-banner&orientation=landscape',
    description: 'Welcome to the Apple Official Store on KenStore. Shop the latest iPhone, iPad, Mac, Apple Watch, and accessories with official warranty and fast delivery across Kenya.',
    category: 'official-stores',
    followers: 52300,
    rating: 4.8,
    totalProducts: 89,
    joinedYear: 2020,
    tags: ['electronics', 'smartphones', 'laptops', 'accessories'],
  },
  {
    id: 's3',
    name: 'Nike',
    slug: 'nike',
    logo: 'https://readdy.ai/api/search-image?query=Nike%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-nike-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Nike%20sports%20retail%20store%20interior%20modern%20dynamic%20design%20with%20athletic%20product%20displays%20inspirational%20branding%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-nike-banner&orientation=landscape',
    description: 'Welcome to the Nike Official Store on KenStore. Get the latest sneakers, sports apparel, and athletic gear with authentic quality guaranteed.',
    category: 'official-stores',
    followers: 61200,
    rating: 4.7,
    totalProducts: 234,
    joinedYear: 2020,
    tags: ['fashion', 'shoes', 'sports', 'apparel'],
  },
  {
    id: 's4',
    name: 'Adidas',
    slug: 'adidas',
    logo: 'https://readdy.ai/api/search-image?query=Adidas%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-adidas-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Adidas%20sportswear%20retail%20store%20interior%20modern%20athletic%20design%20with%20product%20displays%20and%20three%20stripe%20branding%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-adidas-banner&orientation=landscape',
    description: 'Welcome to the Adidas Official Store on KenStore. Shop performance footwear, sportswear, and lifestyle collections with official quality assurance.',
    category: 'official-stores',
    followers: 48700,
    rating: 4.5,
    totalProducts: 198,
    joinedYear: 2021,
    tags: ['fashion', 'shoes', 'sports', 'apparel'],
  },
  {
    id: 's5',
    name: 'Sony',
    slug: 'sony',
    logo: 'https://readdy.ai/api/search-image?query=Sony%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-sony-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Sony%20electronics%20retail%20store%20interior%20modern%20design%20with%20product%20displays%20for%20cameras%20audio%20and%20gaming%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-sony-banner&orientation=landscape',
    description: 'Welcome to the Sony Official Store on KenStore. Explore premium audio, cameras, TVs, gaming consoles, and entertainment devices with official Sony warranty.',
    category: 'official-stores',
    followers: 32400,
    rating: 4.6,
    totalProducts: 112,
    joinedYear: 2021,
    tags: ['electronics', 'audio', 'cameras', 'gaming'],
  },
  {
    id: 's6',
    name: 'LG',
    slug: 'lg',
    logo: 'https://readdy.ai/api/search-image?query=LG%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-lg-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=LG%20electronics%20retail%20store%20interior%20modern%20design%20with%20TV%20and%20appliance%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-lg-banner&orientation=landscape',
    description: 'Welcome to the LG Official Store on KenStore. Discover cutting-edge TVs, home appliances, and electronics that make life good — with official LG warranty.',
    category: 'official-stores',
    followers: 28900,
    rating: 4.4,
    totalProducts: 95,
    joinedYear: 2021,
    tags: ['electronics', 'tvs', 'appliances', 'home'],
  },
  {
    id: 's7',
    name: 'HP',
    slug: 'hp',
    logo: 'https://readdy.ai/api/search-image?query=HP%20Hewlett%20Packard%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-hp-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=HP%20computer%20and%20printer%20retail%20store%20interior%20modern%20design%20with%20laptop%20displays%20on%20clean%20counters%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-hp-banner&orientation=landscape',
    description: 'Welcome to the HP Official Store on KenStore. Shop laptops, desktops, printers, and accessories with official HP warranty and great deals.',
    category: 'official-stores',
    followers: 19800,
    rating: 4.3,
    totalProducts: 78,
    joinedYear: 2022,
    tags: ['computing', 'laptops', 'printers', 'accessories'],
  },
  {
    id: 's8',
    name: 'Dell',
    slug: 'dell',
    logo: 'https://readdy.ai/api/search-image?query=Dell%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-dell-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Dell%20computer%20retail%20store%20interior%20modern%20design%20with%20laptop%20and%20monitor%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-dell-banner&orientation=landscape',
    description: 'Welcome to the Dell Official Store on KenStore. Get powerful Inspiron, XPS, and Latitude laptops plus monitors with official warranty.',
    category: 'official-stores',
    followers: 16500,
    rating: 4.4,
    totalProducts: 64,
    joinedYear: 2022,
    tags: ['computing', 'laptops', 'monitors', 'business'],
  },
  {
    id: 's9',
    name: 'Canon',
    slug: 'canon',
    logo: 'https://readdy.ai/api/search-image?query=Canon%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-canon-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Canon%20camera%20and%20imaging%20retail%20store%20interior%20modern%20design%20with%20camera%20and%20lens%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-canon-banner&orientation=landscape',
    description: 'Welcome to the Canon Official Store on KenStore. Find DSLR cameras, mirrorless bodies, lenses, printers, and imaging accessories with official warranty.',
    category: 'official-stores',
    followers: 14300,
    rating: 4.5,
    totalProducts: 58,
    joinedYear: 2022,
    tags: ['cameras', 'imaging', 'printers', 'lenses'],
  },
  {
    id: 's10',
    name: 'Lenovo',
    slug: 'lenovo',
    logo: 'https://readdy.ai/api/search-image?query=Lenovo%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-lenovo-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Lenovo%20computer%20retail%20store%20interior%20modern%20design%20with%20laptop%20and%20tablet%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-lenovo-banner&orientation=landscape',
    description: 'Welcome to the Lenovo Official Store on KenStore. Shop ThinkPad, IdeaPad, Legion gaming laptops, and tablets with official warranty.',
    category: 'official-stores',
    followers: 12100,
    rating: 4.3,
    totalProducts: 52,
    joinedYear: 2022,
    tags: ['computing', 'laptops', 'tablets', 'gaming'],
  },
  {
    id: 's11',
    name: 'Hisense',
    slug: 'hisense',
    logo: 'https://readdy.ai/api/search-image?query=Hisense%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-hisense-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Hisense%20electronics%20and%20appliance%20retail%20store%20interior%20modern%20design%20with%20TV%20and%20refrigerator%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-hisense-banner&orientation=landscape',
    description: 'Welcome to the Hisense Official Store on KenStore. Discover affordable TVs, refrigerators, air conditioners, and home appliances with official warranty.',
    category: 'official-stores',
    followers: 9800,
    rating: 4.2,
    totalProducts: 45,
    joinedYear: 2023,
    tags: ['electronics', 'tvs', 'appliances', 'home'],
  },
  {
    id: 's12',
    name: 'Oraimo',
    slug: 'oraimo',
    logo: 'https://readdy.ai/api/search-image?query=Oraimo%20brand%20logo%20on%20clean%20white%20background%20minimal%20corporate%20logo%20design%20professional%20branding%20photography%20high%20detail&width=200&height=200&seq=store-oraimo-logo&orientation=squarish',
    banner: 'https://readdy.ai/api/search-image?query=Oraimo%20mobile%20accessories%20retail%20store%20interior%20modern%20design%20with%20headphones%20power%20banks%20and%20smartwatch%20displays%20professional%20architectural%20photography%20wide%20angle&width=1400&height=360&seq=store-oraimo-banner&orientation=landscape',
    description: 'Welcome to the Oraimo Official Store on KenStore. Shop premium power banks, earphones, smartwatches, and mobile accessories with official warranty.',
    category: 'official-stores',
    followers: 22100,
    rating: 4.3,
    totalProducts: 87,
    joinedYear: 2021,
    tags: ['accessories', 'audio', 'power', 'smartwatch'],
  },
];

export const getStoreBySlug = (slug: string): Store | undefined =>
  stores.find((s) => s.slug === slug);